import React, { type FC } from 'react';

export const DateSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 6.5V4.5H15V6.5H9V4.5H7V6.5H5V7.5V17.5V19.5H19V17.5V7.5V6.5H17ZM17 17.5H7V10.5H17V18.5V17.5Z"
                fill="#3A3247"
            />
        </svg>
    );
};
